import { z } from 'zod'
import { privateToAddress } from '@ethereumjs/util'
import { ValueObject } from '@lukso/controllerapps-sharedlogic-ddd-core'
import { Address } from '@lukso/controllerapps-sharedlogic-primitives'

import { PrivateKey } from './PrivateKey'

const AccountPropsSchema = z.object({
  privateKey: z.instanceof(PrivateKey),
})

type AccountProps = z.infer<typeof AccountPropsSchema>

export class Account extends ValueObject<AccountProps> {
  public getAddress(): Address {
    const addressBufferValue = privateToAddress(
      this.props.privateKey.getValue()
    )
    return Address.createFromBuffer(addressBufferValue)
  }

  public getPrivateKey(): PrivateKey {
    return this.props.privateKey
  }

  public equals(other: Account): boolean {
    return this.props.privateKey.equals(other.getPrivateKey())
  }

  public static create(props: AccountProps): Account {
    const validatedProps = AccountPropsSchema.parse(props)
    return new Account(validatedProps)
  }
}
